import { connect } from "react-redux";
import { sendGAEvent } from "rivals/redux/ga/actions";
import { getSubscriptionsConstants } from "rivals/redux/rails/selectors";
import { State } from "rivals/redux/reducer";
import { reactivateSubscription } from "rivals/redux/subscription/actions";
import { getSubscriptions as getSubscriptionsAction } from "rivals/redux/user/actions";
import {
  getSubmitting,
  getSubscriptions,
  isLoading
} from "rivals/redux/user/selectors";
import { StateProps } from "./types";
import Subscriptions from ".";

const mapStateToProps = (state: State): StateProps => ({
  isLoading: isLoading(state),
  isSubmitting: getSubmitting(state),
  subscriptions: getSubscriptions(state),
  subscriptionsConstants: getSubscriptionsConstants(state)
});

const mapDispatchToProps = {
  getSubscriptions: getSubscriptionsAction,
  reactivateSubscription,
  sendGAEvent
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
